import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/* eslint implicit-arrow-linebreak: 0 */
/* eslint arrow-parens: 0 */
/* eslint no-param-reassign: 0 */

import produce from 'immer';
import _curry from 'lodash/curry';
import _reduce from 'lodash/reduce';
import _mapValues from 'lodash/mapValues';
import _property from 'lodash/property';
import _invert from 'lodash/invert';
import _isEmpty from 'lodash/isEmpty';
import _filter from 'lodash/filter';
import _keyBy from 'lodash/keyBy';
import castArrayIfPresent from '@tekion/tekion-base/utils/castArrayIfPresent';

// Readers
import filterGroupReader, { filterReader } from '../../readers/FilterGroup';

// Helpers
import { getUniqueFieldId, getSelectedFilterGroup } from './filterDialog.general';
import makeFilterRowField from './filterDialog.makeField';

// Constants
import { DEFAULT_FILTER_GROUP } from '../../constants/filterSection.filterGroups';
import FILTER_TYPES from '../../constants/filterSection.filterTypes';
var updateFilterIfRequired = produce(function (filter) {
  if (filter.type === FILTER_TYPES.MONTH_PICKER) {
    filter.values = castArrayIfPresent(filter.values);
  }
});
var mapFilterToValue = function mapFilterToValue(valuesMap, filter) {
  var rowId = getUniqueFieldId();
  valuesMap[rowId] = updateFilterIfRequired(filter);
  return valuesMap;
};
var mapFiltersToValuesMap = function mapFiltersToValuesMap(filters) {
  return _reduce(filters, mapFilterToValue, {});
};
var mapValuesToField = _curry(function (defaultFilterTypes, filterTypes, selectedFilterGroup, isReadOnly, value, rowId, valuesMap) {
  var field = makeFilterRowField(defaultFilterTypes, filterTypes, valuesMap, rowId, selectedFilterGroup, isReadOnly);
  return field;
});
var getFilterTypeValue = _property('type');
var getFilterTypeIdToRowId = function getFilterTypeIdToRowId(valuesMap) {
  var rowIdToFilterTypeId = _mapValues(valuesMap, getFilterTypeValue);
  var filterTypeIdToRowId = _invert(rowIdToFilterTypeId);
  return filterTypeIdToRowId;
};
var mapFilterToRowId = _curry(function (filterTypeIdToRowId, acc, filter) {
  var filterTypeId = filterReader.type(filter);
  var rowId = filterTypeIdToRowId[filterTypeId];
  if (rowId) {
    acc.push(rowId);
  }
  return acc;
});
var mapFiltersToSectionRows = function mapFiltersToSectionRows(filterTypeIdToRowId, filters) {
  var sectionRows = _reduce(filters, mapFilterToRowId(filterTypeIdToRowId), []);
  return sectionRows;
};

// TODO: Add support for edited mode of filter groups.

var isFilterGroupNotSelected = _curry(function (selectedFiltersByType, groupFilter) {
  var type = filterReader.type(groupFilter);
  var isGroupFilterSelected = selectedFiltersByType[type];
  return !isGroupFilterSelected;
});
var getFilters = function getFilters(selectedFilterGroupId, groupFilters, selectedFilters) {
  if (_isEmpty(selectedFilters)) {
    return groupFilters;
  }

  /** Default filters cannot be removed hance we will have to show their rows. */
  if (selectedFilterGroupId === DEFAULT_FILTER_GROUP) {
    var selectedFiltersByType = _keyBy(selectedFilters, 'type');
    var notSelectedGroupFilters = _filter(groupFilters, isFilterGroupNotSelected(selectedFiltersByType));
    return [].concat(_toConsumableArray(selectedFilters), _toConsumableArray(notSelectedGroupFilters));
  }
  return selectedFilters;
};

/**
 * Generates the initialValuesMap based on the selected filter group.
 * @param {Array} filterGroups: List of all the filter groups for the particular module type.
 * @param {String} selectedFilterGroupId: ID of the selected filter group.
 */
export var getInitialValues = function getInitialValues(filterGroups, selectedFilterGroupId, selectedFilters) {
  var selectedFilterGroup = getSelectedFilterGroup(selectedFilterGroupId, filterGroups);
  var groupFilters = filterGroupReader.filters(selectedFilterGroup);
  var filters = getFilters(selectedFilterGroupId, groupFilters, selectedFilters);
  var valuesMap = mapFiltersToValuesMap(filters);
  return valuesMap;
};
export var getSectionRows = function getSectionRows(valuesMap, selectedFilters) {
  var filterTypeIdToRowId = getFilterTypeIdToRowId(valuesMap);
  var sectionRows = mapFiltersToSectionRows(filterTypeIdToRowId, selectedFilters);
  return sectionRows;
};
export var getFields = function getFields(defaultFilterTypes, valuesMap, filterTypes, filterGroups, selectedFilterGroupId, isReadOnly) {
  var selectedFilterGroup = getSelectedFilterGroup(selectedFilterGroupId, filterGroups);
  return _mapValues(valuesMap, mapValuesToField(defaultFilterTypes, filterTypes, selectedFilterGroup, isReadOnly));
};